import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = { class: "w-full flex flex-col md:flex-row justify-center items-center h-auto md:h-10 py-2 bg-mcgard-gray-400 px-5 md:px" }
const _hoisted_3 = ["href"]
const _hoisted_4 = ["innerHTML"]

import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import {
  footerUrls,
} from '@/configs/footer';


export default /*#__PURE__*/_defineComponent({
  __name: 'FooterSection',
  setup(__props) {

const { locale } = useI18n();

const footerItems = computed(() => {
  return footerUrls.map((item: any) => {
    return {
      label: item.label,
      link: item.link[locale.value.toLowerCase()],
    };
  });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(footerItems), (item, index) => {
        return (_openBlock(), _createElementBlock("a", {
          key: `footerItems${index}`,
          class: "my-1.5 md:mx-4 text-xs uppercase text-mcgard-gray-900",
          href: item.link,
          target: "_blank"
        }, [
          _createElementVNode("span", {
            class: "cursor-pointer hover:font-semibold",
            innerHTML: _ctx.$t(item.label)
          }, null, 8, _hoisted_4)
        ], 8, _hoisted_3))
      }), 128))
    ])
  ]))
}
}

})